import React, { useState, useEffect } from "react";
import { DateTimePicker } from "@mui/x-date-pickers";

export const MyDateTimePicker = (props) => {
  const [selectedDate, setSelectedDate] = useState(props.value ? new Date(props.value) : null);

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  useEffect(() => {
    setSelectedDate(props.value ? new Date(props.value) : null);
  }, [props.value]);

  const className = "mt-3 mb-3 " + props.className;

  return (
    <DateTimePicker
      views={["year", "month", "day", "hours", "minutes"]}
      InputProps={{ readOnly: true }}
      className={className}
      error={props.error}
      helperText={props.helperText}
      placeholder={props.placeholder ? props.placeholder : "ÅÅÅÅ-MM-DD HH:mm"}
      format="yyyy-MM-dd HH:mm"
      ampm={false}
      disableToolbar
      clearable={props.clearable}
      maxDate={props.maxDate}
      minDate={props.minDate}
      variant="outlined"
      slotProps={{
        textField: {
          required: props.required,
          error: props.error,
          placeholder: props.placeholder ? props.placeholder : "ÅÅÅÅ-MM-DD",
          size: props.size ? props.size : "medium",
          style: { width: "100%", ...props.style },
          helperText: props.helperText,
        },
      }}
      margin="normal"
      label={props.label}
      size={props.size ? props.size : "medium"}
      value={selectedDate}
      onChange={handleDateChange}
      onAccept={props.onAccept}
      KeyboardButtonProps={{
        "aria-label": "change date",
      }}
      cancelLabel={props.cancelLabel ? props.cancelLabel : "Avbryt"}
      okLabel={props.okLabel ? props.okLabel : "OK"}
    />
  );
};
